module.exports = __webpack_public_path__ + "static/img/Laodong.0bb3da55.png";